'use strict';

(function () {

  angular
    .module('specsguardApp')
    .component('sgProjectLocation', {
      bindings: {
        project: '<',
        updateProject: '&'
      },
      templateUrl: 'app-legacy/project/administration/project.location.html',
      controller: 'ProjectLocationCtrl'
    });

})();
